<div class="logo" *ngIf="Redesign">
  <img src="assets/general/logo.png" />
  <p>بنتو</p>
</div>
<p [ngClass]="{ 'title-old': !Redesign, title: Redesign }" *ngIf="!expire">
  {{ title }}
</p>

<div>
  <div [ngClass]="expire ? 'picker-date' : 'picker-wrapper'">
    <div
      id="days_holder"
      (swipeup)="swipe($event.type, 'days', $event)"
      (swipedown)="swipe($event.type, 'days', $event)"
    ></div>
    <div
      id="months_holder"
      (swipeup)="swipe($event.type, 'months', $event)"
      (swipedown)="swipe($event.type, 'months', $event)"
    ></div>
    <div
      id="years_holder"
      (swipeup)="swipe($event.type, 'years', $event)"
      (swipedown)="swipe($event.type, 'years', $event)"
    ></div>

    <div
      class="line"
      [ngClass]="{ 'line-up-old': !Redesign, 'line-up': Redesign }"
    ></div>
    <div
      class="line"
      [ngClass]="{ 'line-down-old': !Redesign, 'line-down': Redesign }"
    ></div>

    <div id="days">
      <div class="picker-item" *ngFor="let day of days">
        {{ day }}
      </div>
    </div>
    <div id="months">
      <div class="picker-item" *ngFor="let month of months">
        {{ month }}
      </div>
    </div>
    <div id="years">
      <div class="picker-item" *ngFor="let year of years">
        {{ year }}
      </div>
    </div>
  </div>
</div>
